import { render, staticRenderFns } from "./mr.vue?vue&type=template&id=43ab47b1&scoped=true&"
var script = {}
import style0 from "./mr.vue?vue&type=style&index=0&id=43ab47b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab47b1",
  null
  
)

export default component.exports